import React, { useState } from 'react';
import { 
  FaUndo, 
  FaMoneyBillWave, 
  FaClock, 
  FaCheckCircle, 
  FaTimesCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaEnvelope,
  FaFileAlt,
  FaArrowLeft
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './CancellationRefunds.css';

const CancellationRefunds = () => {
  const [activeTab, setActiveTab] = useState('cancellation');
  const [formData, setFormData] = useState({
    orderNumber: '',
    reason: '',
    email: '',
    phone: '',
    message: ''
  });

  const refundReasons = [
    'Product defective',
    'Wrong item received',
    'Size not fitting',
    'Quality issues',
    'Damaged during shipping',
    'Other'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    alert('Your refund request has been submitted. We will contact you within 24 hours.');
  };

  return (
    <div className="cancellation-refunds-page">
      <div className="container">
        {/* Header */}
        <div className="page-header">
          <Link to="/" className="back-link">
            <FaArrowLeft /> Back to Home
          </Link>
          <h1>Cancellation & Refunds</h1>
          <p>We're here to help with your order concerns</p>
        </div>

        {/* Tabs */}
        <div className="tabs-container">
          <button 
            className={`tab-button ${activeTab === 'cancellation' ? 'active' : ''}`}
            onClick={() => setActiveTab('cancellation')}
          >
            <FaUndo /> Cancellation Policy
          </button>
          <button 
            className={`tab-button ${activeTab === 'refund' ? 'active' : ''}`}
            onClick={() => setActiveTab('refund')}
          >
            <FaMoneyBillWave /> Refund Request
          </button>
        </div>

        {/* Content */}
        <div className="content-container">
          {activeTab === 'cancellation' && (
            <div className="tab-content">
              <div className="info-section">
                <h2><FaUndo /> Cancellation Policy</h2>
                <div className="info-cards">
                  <div className="info-card">
                    <FaClock className="icon" />
                    <h3>Before Dispatch</h3>
                    <p>Orders can be cancelled within 24 hours of placement or before dispatch. Full refund will be processed.</p>
                  </div>
                  <div className="info-card">
                    <FaExclamationTriangle className="icon" />
                    <h3>After Dispatch</h3>
                    <p>Orders already dispatched cannot be cancelled. You can return the product after delivery for a refund.</p>
                  </div>
                  <div className="info-card">
                    <FaCheckCircle className="icon" />
                    <h3>Refund Timeline</h3>
                    <p>Refunds are processed within 5-7 business days to your original payment method.</p>
                  </div>
                </div>
                
                <div className="policy-note">
                  <h3>How to Cancel Your Order</h3>
                  <p>To cancel your order, please contact us immediately:</p>
                  <ul>
                    <li><strong>Email:</strong> info@vastrebyvijh.com</li>
                  </ul>
                  <p>Please have your order number ready when contacting us.</p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'refund' && (
            <div className="tab-content">
              <div className="info-section">
                <h2><FaMoneyBillWave /> Refund Policy</h2>
                <div className="info-cards">
                  <div className="info-card">
                    <FaCheckCircle className="icon" />
                    <h3>Eligible for Refund</h3>
                    <ul>
                      <li>Defective or damaged products</li>
                      <li>Wrong item received</li>
                      <li>Size not fitting (unworn condition)</li>
                      <li>Quality issues</li>
                      <li>Items returned within 7 days of delivery</li>
                    </ul>
                  </div>
                  <div className="info-card">
                    <FaTimesCircle className="icon" />
                    <h3>Not Eligible for Refund</h3>
                    <ul>
                      <li>Items worn or used</li>
                      <li>Customized or personalized items</li>
                      <li>Items returned after 7 days</li>
                      <li>Items without original tags</li>
                      <li>Items damaged by customer</li>
                    </ul>
                  </div>
                  <div className="info-card">
                    <FaClock className="icon" />
                    <h3>Refund Process</h3>
                    <ol>
                      <li>Submit refund request</li>
                      <li>We'll review within 24 hours</li>
                      <li>Return shipping label provided</li>
                      <li>Refund processed after inspection</li>
                      <li>Money credited in 5-7 business days</li>
                    </ol>
                  </div>
                </div>
              </div>

              
            </div>
          )}
        </div>

        {/* Contact Information */}
        <div className="contact-section">
          <h3><FaInfoCircle /> Need Help?</h3>
          <div className="contact-cards">
            <div className="contact-card">
              <FaEnvelope className="icon" />
              <h4>Email Us</h4>
              <p>info@vastrebyvijh.com</p>
              <small>Response within 24 hours</small>
            </div>
            <div className="contact-card">
              <FaFileAlt className="icon" />
              <h4>Terms & Conditions</h4>
              <p>Read our full policy</p>
              <small><Link to="/terms">View Terms</Link></small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationRefunds;
